/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IngestionSourceType } from '../models/IngestionSourceType';
import { S3SourceProperties } from '../models/S3SourceProperties';

export class CreateIngestionPipelineInput {
  /**
  * The name of the ingestion pipeline
  */
  'name': string;
  'sourceType': IngestionSourceType;
  's3SourceProperties': S3SourceProperties;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceType",
      "baseName": "sourceType",
      "type": "IngestionSourceType",
      "format": ""
    },
    {
      "name": "s3SourceProperties",
      "baseName": "s3SourceProperties",
      "type": "S3SourceProperties",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateIngestionPipelineInput.attributeTypeMap;
  }

  public constructor() {
  }
}



